import {Grid, Group, Modal, ModalProps, Tabs, Text, Title} from "@mantine/core";
import {compareString, TtaMappedPairEntity} from "@ots-frontend/ots-data";
import {FormattedQuantity} from "../../text/FormattedQuantity/FormattedQuantity";
import {IconCircleXFilled, IconLayersDifference} from "@tabler/icons-react";
import {FormattedDatabaseCode} from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";
import {FormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {FormattedCurrency} from "../../text/FormattedCurrency/FormattedCurrency";

const options: Intl.NumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 5
}

const CompareGrid = (props: { ttaPair: TtaMappedPairEntity }) => {
  const {ttaPair: {tta, dbTta}} = props

  return (
    <Grid>
      <Grid.Col span={6}>
        <>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Total Cost
          </Text>
          <Group spacing="xs">
            {tta?.totalCost !== dbTta?.getTotalCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.totalCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Time Cost
          </Text>
          <Group spacing="xs">
            {tta?.timeCost !== dbTta?.getTimeCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.timeCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Freight Cost
          </Text>
          <Group spacing="xs">
            {tta?.freightCost !== dbTta?.getFreightCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.freightCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Load Cost
          </Text>
          <Group spacing="xs">
            {tta?.loadCost !== dbTta?.getLoadCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.loadCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Fuel Surcharge Cost
          </Text>
          <Group spacing="xs">
            {tta?.fuelSurchargeCost !== dbTta?.getFuelSurchargeCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.fuelSurchargeCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Demmurage Cost
          </Text>
          <Group spacing="xs">
            {tta?.demmurageCost !== dbTta?.getDemmurageCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.demmurageCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Reject Cost
          </Text>
          <Group spacing="xs">
            {tta?.rejectCost !== dbTta?.getRejectCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.rejectCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Split Load Cost
          </Text>
          <Group spacing="xs">
            {tta?.splitLoadCost !== dbTta?.getSplitLoadCost("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.splitLoadCost}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Time
          </Text>
          <Group spacing="xs">
            {tta?.billableHours !== dbTta?.getBillableHours("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.billableHours}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Qty
          </Text>
          <Group spacing="xs">
            {tta?.billableQty !== dbTta?.getBillableQty("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.billableQty}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Freight Qty
          </Text>
          <Group spacing="xs">
            {tta?.billableFreightQty !== dbTta?.getBillableFreightQty("Hauling") &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.billableFreightQty}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Rejected
          </Text>
          <Group spacing="xs">
            {compareString(tta?.pickupTransport?.rejectionType?.code, dbTta?.pickupTransport?.rejectionType?.code) !== 0 &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            {tta?.pickupTransport?.rejectionType ? (
              <FormattedDatabaseCode value={tta.pickupTransport.rejectionType}/>
            ) : (
              "No")
            }
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Mileage
          </Text>
          <Group spacing="xs">
            {tta?.mileage !== dbTta?.mileage &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.mileage}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Fuel Price
          </Text>
          <Group spacing="xs">
            {tta?.fuelPrice !== dbTta?.fuelPrice &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedCurrency
              value={tta?.fuelPrice}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Date
          </Text>
          <Group spacing="xs">
            {tta?.pickupTransport?.createDttm !== dbTta?.pickupTransport?.createDttm &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedDateTime
              date={tta?.pickupTransport?.createDttm}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Date
          </Text>
          <Group spacing="xs">
            {tta?.deliveryTransport?.createDttm !== dbTta?.deliveryTransport?.createDttm &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedDateTime
              date={tta?.deliveryTransport?.createDttm}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Quantity
          </Text>
          <Group spacing="xs">
            {tta?.pickupTransport?.quantityDecimal !== dbTta?.pickupTransport?.quantityDecimal &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.pickupTransport?.quantityDecimal}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Net Quantity
          </Text>
          <Group spacing="xs">
            {tta?.pickupTransport?.netQuantity !== dbTta?.pickupTransport?.netQuantity &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <FormattedQuantity
              value={tta?.pickupTransport?.netQuantity}
              options={options}
            />
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Site
          </Text>
          <Group spacing="xs">
            {compareString(tta?.pickupTransport?.siteName, dbTta?.pickupTransport?.siteName) !== 0 &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <DefaultText
              value={tta?.pickupTransport?.siteName}/>
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Container
          </Text>
          <Group spacing="xs">
            {compareString(tta?.pickupTransport?.containerName, dbTta?.pickupTransport?.containerName) !== 0 &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <DefaultText
              value={tta?.pickupTransport?.containerName}/>
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Site
          </Text>
          <Group spacing="xs">
            {compareString(tta?.deliveryTransport?.siteName, dbTta?.deliveryTransport?.siteName) != 0 &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <DefaultText
              value={tta?.deliveryTransport?.siteName}/>
          </Group>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Container
          </Text>
          <Group spacing="xs">
            {compareString(tta?.deliveryTransport?.containerName, dbTta?.deliveryTransport?.containerName) !== 0 &&
              <Text c="red">
                <IconCircleXFilled size={14}/>
              </Text>
            }
            <DefaultText
              value={tta?.deliveryTransport?.containerName}/>
          </Group>

        </>
      </Grid.Col>
      <Grid.Col span={6}>
        <>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Total Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getTotalCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Time Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getTimeCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Freight Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getFreightCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Load Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getLoadCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Fuel Surcharge Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getFuelSurchargeCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Demmurage Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getDemmurageCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Reject Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getRejectCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Split Load Cost
          </Text>
          <FormattedCurrency
            value={dbTta?.getSplitLoadCost("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Time
          </Text>
          <FormattedQuantity
            value={dbTta?.getBillableHours("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Qty
          </Text>
          <FormattedQuantity
            value={dbTta?.getBillableQty("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Billable Freight Qty
          </Text>
          <FormattedQuantity
            value={dbTta?.getBillableFreightQty("Hauling")}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Rejected
          </Text>
          {dbTta?.pickupTransport?.rejectionType ? (
            <FormattedDatabaseCode value={dbTta.pickupTransport.rejectionType}/>
          ) : (
            "No")
          }

          <Text ta="left" fz="sm" weight={500} mt="md">
            Mileage
          </Text>
          <FormattedQuantity
            value={dbTta?.mileage}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Fuel Price
          </Text>
          <FormattedCurrency
            value={dbTta?.fuelPrice}
            options={options}
          />

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Date
          </Text>
          <FormattedDateTime
            date={dbTta?.pickupTransport?.createDttm}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Date
          </Text>
          <FormattedDateTime
            date={dbTta?.deliveryTransport?.createDttm}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Quantity
          </Text>
          <FormattedQuantity
            value={dbTta?.pickupTransport?.quantityDecimal}
            options={options}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Net Quantity
          </Text>
          <FormattedQuantity
            value={dbTta?.pickupTransport?.netQuantity}
            options={options}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Site
          </Text>
          <DefaultText
            value={dbTta?.pickupTransport?.siteName}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Pickup Container
          </Text>
          <DefaultText
            value={dbTta?.pickupTransport?.containerName}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Site
          </Text>
          <DefaultText
            value={dbTta?.deliveryTransport?.siteName}/>

          <Text ta="left" fz="sm" weight={500} mt="md">
            Delivery Container
          </Text>
          <DefaultText
            value={dbTta?.deliveryTransport?.containerName}/>
        </>
      </Grid.Col>
    </Grid>
  )
}

export type TicketCompareModalProps = ModalProps & {
  value: TtaMappedPairEntity
}

export const TicketCompareModal = (props: TicketCompareModalProps) => {
  const {value, ...rest} = props

  return (
    <Modal {...rest}>
      <Tabs defaultValue="compare">
        <Tabs.List>
          <Tabs.Tab value="compare" icon={<IconLayersDifference size="0.8rem"/>}>Compare</Tabs.Tab>
          <Tabs.Tab value="data">Data</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="compare" pt="xs">
          <Grid>
            <Grid.Col span={12}>
              <Grid>
                <Grid.Col span={6}>
                  <Title order={4}>
                    File
                  </Title>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Title order={4}>
                    Internal Record
                  </Title>
                </Grid.Col>
              </Grid>
            </Grid.Col>
            <Grid.Col span={12}>
              <CompareGrid ttaPair={value}/>
            </Grid.Col>
          </Grid>
        </Tabs.Panel>
        <Tabs.Panel value="data" pt="xs">
          <Grid>
            {value.data &&
              Object.entries(value.data).map((entry, index) => {
                return (
                  <>
                    <Grid.Col span={6} key={index + "_key"}>
                      <Text weight={600} align="right">
                        {entry[0]}:
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={6} key={index + "_value"}>
                      <Text align="left">
                        {entry[1]}
                      </Text>
                    </Grid.Col>
                  </>
                )
              })
            }
          </Grid>
        </Tabs.Panel>
      </Tabs>
    </Modal>
  )
}
